import { useStaticQuery, graphql } from "gatsby"

export const usePageCommonItemsQuery = () => {
  const { wp } = useStaticQuery(
    graphql`
    query PageCommonItemsQuery {
        wp {
          acfOptionsCommonItems {
            commonItems {
              commonItemsButtonText
              commonItemsInteriorHeroImageDefault{
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: NONE, quality: 100, layout: FULL_WIDTH)
                  }
                }
              }
              commonItemsInteriorHeroImageDefaultAltText
              commonItemsInteriorContentImageDefault{
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
              commonItemsInteriorContentImageDefaultAltText
              commonItemsInteriorCalloutImage{
                  localFile{
                      childImageSharp{
                          gatsbyImageData
                      }
                  }
              }
              commonItemsInteriorCalloutImageAltText
              commonItemsInteriorCalloutText
              commonItemsInteriorCalloutLink{
                  title
                  url
              }
            }
          }
        }
      }
    `
  )
  return wp.acfOptionsCommonItems.commonItems
}
